import { Helmet } from "react-helmet";
import Navbar from "../components/universal/navbar";
import Header from "../components/dental-plans/hero";
import What from "../components/dental-plans/what";
import Why from "../components/dental-plans/why";
import Plan from "../components/dental-plans/pricing-plans";
import CTA from "../components/universal/cta";
import Contact from "../components/universal/contact";
import Partners from "../components/universal/partners";
import Footer from "../components/universal/footer";

function Index() {
  return (
    <div>
      <Helmet>
        <title>Dental Payment Plans | Denplan | Regent Dental</title>
        <meta
          name="description"
          content="Affordable dental plans in West Yorkshire to keep your oral health on track. Regent Dental offers flexible payment options for preventive and routine care."
        />
        <link
          rel="canonical"
          href="https://www.regent-dental.co.uk/dental-plans"
        />
      </Helmet>
      <Navbar />
      <Header />
      <What />
      <Why />
      <Plan />
      <CTA />
      <Partners />
      <Contact />
      <Footer />
    </div>
  );
}

export default Index;
